<template>
  <div class="listar-producto-final-bulk  mt-4">

    <!-- Título -->
    <h3 class="mb-2 text-bulk">
      <font-awesome-icon icon="box" class="me-2" />
      Productos Finales Bulk
    </h3>

    <!-- Indicador de vista actual -->
    <div class="mb-4">
      <span class="badge fs-6 px-3 py-2 rounded-pill"
        :class="sinStock ? 'bg-danger-subtle text-danger fw-bold' : 'bg-success-subtle text-success fw-bold'">
        {{ sinStock ? 'SIN Stock' : 'Con Stock Disponible' }}
      </span>
    </div>



    <!-- Filtros -->
    <div class="toolbar bg-bulk-light border rounded p-3 d-flex flex-wrap gap-3 mb-4">
      <div class="flex-grow-1">
        <label class="small fw-semibold text-secondary">Código Materia Prima</label>
        <input v-model="filtros.codigo_materia" type="text" class="form-control" placeholder="Ej: MAT-001" />
      </div>
      <div class="flex-grow-1">
        <label class="small fw-semibold text-secondary">Código Lote</label>
        <input v-model="filtros.codigo" type="text" class="form-control" placeholder="Ej: LOTE-001" />
      </div>
      <div class="d-flex align-items-end">
        <button @click="limpiarFiltros" class="btn btn-outline-bulk">Limpiar Filtros</button>
      </div>
    </div>

    <!-- Total -->
    <p class="text-muted mb-4"><strong>{{ filteredBulks.length }}</strong> lote(s) encontrados</p>

    <!-- Loading -->
    <div v-if="loading" class="text-center my-5">
      <div class="spinner-border text-bulk" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <!-- Cards -->
    <div v-else-if="filteredBulks.length" class="row g-3">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3" v-for="item in paginatedBulks" :key="item.id">
        <ProductoFinalGestionCard :producto="item" @editar="editProductoFinal" @ajustar="ajustarCantidad"
          @procesar="procesarEnvasado" />
      </div>
    </div>

    <p v-else class="text-muted">No hay productos pendientes para envasar.</p>

    <!-- Paginación -->
    <nav v-if="totalPages > 1" class="mt-4">
      <ul class="pagination justify-content-center small">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="currentPage--">Anterior</button>
        </li>
        <li v-for="page in totalPages" :key="page" class="page-item" :class="{ active: currentPage === page }">
          <button class="page-link" @click="currentPage = page">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="currentPage++">Siguiente</button>
        </li>
      </ul>
    </nav>

  </div>
</template>




<script>
import axios from '@/axios';
import ProductoFinalGestionCard from './ProductoFinalGestionCard.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: "ListarProductoFinalBulk",
  components: {
    ProductoFinalGestionCard,
    FontAwesomeIcon
  },
  props: {
    sinStock: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bulks: [],
      loading: false,
      currentPage: 1,
      pageSize: 6,
      clubActual: this.$store.getters.getClubActual,
      filtros: {
        codigo_materia: '',
        codigo: ''
      }
    };
  },
  watch: {
    sinStock() {
      this.fetchBulks();
    }
  },
  computed: {
    filteredBulks() {
      return this.bulks.filter(item => {
        return (!this.filtros.codigo_materia || (item.materia_prima?.codigo ?? '').toLowerCase().includes(this.filtros.codigo_materia.toLowerCase())) &&
          (!this.filtros.codigo || item.codigo.toLowerCase().includes(this.filtros.codigo.toLowerCase()));
      });
    },
    paginatedBulks() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredBulks.slice(start, start + this.pageSize);
    },
    totalPages() {
      return Math.ceil(this.filteredBulks.length / this.pageSize);
    }
  },
  methods: {
    async fetchBulks() {
      this.loading = true;
      try {
        const url = this.sinStock
          ? '/api/producto_final_bulk_sin_stock'
          : '/api/producto_final_bulk_con_stock';

        const res = await axios.get(url, {
          params: { club_id: this.clubActual.id }
        });

        this.bulks = res.data || [];


      } catch (error) {
        console.error('Error al listar producto final bulk:', error);
      } finally {
        this.loading = false;
      }
    },
    limpiarFiltros() {
      this.filtros = { codigo_materia: '', codigo: '' };
    },
    editProductoFinal(producto) {
      this.$emit('viewChange', { view: 'editar', productoFinalBulk: producto });
    },
    ajustarCantidad(producto) {
      this.$emit('viewChange', { view: 'ajustarCantidad', productoFinalBulk: producto });
    },
    procesarEnvasado(producto) {
      this.$emit('viewChange', { view: 'procesar', productoFinalBulk: producto });
    }
  },
  mounted() {
    this.fetchBulks();
  }
};
</script>



<style scoped>
.listar-producto-final-bulk {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.05);
}

.text-bulk {
  color: #205375;
  /* Azul petróleo / industrial */
}

.bg-bulk-light {
  background-color: #f2f6fa;
  /* Fondo muy claro, para diferenciar sección */
}

.btn-outline-bulk {
  border-color: #205375;
  color: #205375;
}

.btn-outline-bulk:hover {
  background-color: #205375;
  color: white;
}

.pagination .page-link {
  color: #205375;
}

.pagination .page-item.active .page-link {
  background-color: #205375;
  color: white;
}

.bg-danger-subtle {
  background-color: #fdecea;
}

.bg-success-subtle {
  background-color: #e6f4ea;
}
</style>
